// Globals
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

// Components
import { Modal, ModalSize } from '@/components';
import { StyledButton, StyledMessage } from './DisablePaymentMethodErrorModalStyles';

type TDisablePaymentMethodErrorModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

const DisablePaymentMethodErrorModal: FC<TDisablePaymentMethodErrorModalProps> = ({ isOpen, onClose }) => {
  const { t } = useTranslation(['common']);

  return (
    <Modal
      title={t('error_modal_payment_method_title')}
      size={ModalSize.MEDIUM}
      visible={isOpen}
      onCancel={onClose}
      destroyOnClose
    >
      <StyledMessage>{t('error_modal_payment_method_subtitle')}</StyledMessage>
      <StyledMessage>{t('error_modal_payment_method_description')}</StyledMessage>
      <StyledButton onClick={onClose} type="primary">
        {t('ok_btn')}
      </StyledButton>
    </Modal>
  );
};

export default DisablePaymentMethodErrorModal;
